export default {
    state: {
        searchMode: false,
    },
    getters: {},
    mutations: {
        setShareToMeStatus(state, obj) {
            let key = Object.keys(obj);
            for (let item of key) {
                state[item] = obj[item];
            }
        },
    },
};
